import React from "react"
import { JSX } from "react"
import { Navigate } from "react-router-dom"
import { jwtDecode } from "jwt-decode"
import { API_ROUTES } from "../configuration/RoutesApi"
import { PATH_MAP } from "../configuration/PathMap"

type JwtPayload = {
  exp?: number
  IsAdmin?: string
  AdminEmployee_Id?: string
}

const AdminOnlyRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const token = localStorage.getItem(API_ROUTES.TOKEN_ADMIN)

  if (!token) {
    return <Navigate to={PATH_MAP.ADMIN_LOGIN_PAGE} replace />
  }

  try {
    const rawToken = token.replace(/['"]/g, "")
    
    const decoded = jwtDecode<JwtPayload>(rawToken)

    if (!decoded.exp || decoded.exp < Date.now() / 1000) {
      localStorage.removeItem(API_ROUTES.TOKEN_ADMIN)
      
      return <Navigate to={PATH_MAP.ADMIN_LOGIN_PAGE} replace />
    }

    const isRootAdmin = decoded.IsAdmin === "True"
   
    const isAdminEmployee = Boolean(decoded.AdminEmployee_Id)

    if (!isRootAdmin && !isAdminEmployee) {
      localStorage.removeItem(API_ROUTES.TOKEN_ADMIN)
      
      return <Navigate to={PATH_MAP.ADMIN_LOGIN_PAGE} replace />
    }

    return children
  } catch {
    localStorage.removeItem(API_ROUTES.TOKEN_ADMIN)
    return <Navigate to={PATH_MAP.ADMIN_LOGIN_PAGE} replace />
  }
}

export default AdminOnlyRoute
